"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./SystemTiles.css");
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const SystemTile = props => {
  const {
    accessoryImageUrl,
    accessoryName,
    accessoryType,
    accessoryImageUrlStyle,
    accessoryPartNumber,
    accessoryLife,
    statusImage,
    statusText,
    part,
    installedDateText,
    filterLifeText,
    installedDate,
    arrowImageRight,
    isArrowImageVisible,
    onClickArrowRight,
    variant,
    alertTextStyle,
    description,
    note,
    key,
    statusLevelText,
    statusLevelImage,
    accessoryImageStyle,
    filterDateChangeText,
    filterDateChange,
    filterParts,
    editTextRight,
    editStyle,
    editContainer
  } = props;
  const getVariant = variant => {
    const alertClass = props.alertMessageType === "error" ? 'error-red' : props.alertMessageType === "wran" ? 'warning-orange' : "normal-info";
    switch (variant) {
      case "alert":
        return /*#__PURE__*/_react.default.createElement("div", {
          className: " d-flex flex-column systemInfomation-wrapper-alert"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "d-flex middle-text-wrapper "
        }, accessoryImageUrl ? /*#__PURE__*/_react.default.createElement("div", {
          className: "d-flex justify-content-center left-content-container",
          style: {
            width: 100
          }
        }, /*#__PURE__*/_react.default.createElement("img", {
          src: accessoryImageUrl,
          alt: "",
          style: accessoryImageUrlStyle
        })) : /*#__PURE__*/_react.default.createElement("div", {
          className: "left-content-container",
          style: {
            display: "none",
            width: 100,
            height: "auto",
            left: "-10"
          }
        }, /*#__PURE__*/_react.default.createElement("img", {
          src: accessoryImageUrl,
          alt: "",
          style: accessoryImageUrlStyle
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: "d-flex right-content-container"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "system-content"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "system-text-content"
        }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
          headerStyle: {
            fontSize: 16,
            fontWeight: 600,
            color: '#333333',
            margin: 2
          },
          variant: "header-text",
          headerText: accessoryName
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "tile-alert-container"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "d-flex align-items-center",
          style: {
            width: "28px"
          }
        }, props.alertImageLeft && /*#__PURE__*/_react.default.createElement("img", {
          alt: "",
          src: props.alertImageLeft,
          className: "alert-image",
          style: {
            paddingRight: 0
          }
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: "d-flex flex-column ".concat(alertClass),
          style: {
            marginRight: "auto"
          }
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "tile-alert-text-style",
          style: _objectSpread({
            fontSize: "13px !important",
            lineHeight: "20px !important",
            fontWeight: "600 !important",
            fontFamily: "Poppins !important",
            fontStyle: "normal !important"
          }, alertTextStyle)
        }, props.alertText)), /*#__PURE__*/_react.default.createElement("div", null, isArrowImageVisible && /*#__PURE__*/_react.default.createElement("div", {
          style: {
            width: "60px"
          }
        })))), isArrowImageVisible ? /*#__PURE__*/_react.default.createElement("div", {
          onClick: onClickArrowRight,
          "data-testid": "arrowClick"
        }, /*#__PURE__*/_react.default.createElement("img", {
          src: arrowImageRight,
          alt: "",
          className: "arrow-right-style"
        })) : null))), /*#__PURE__*/_react.default.createElement("div", {
          className: "d-flex flex-column",
          style: {
            marginRight: "auto",
            marginTop: 15
          }
        }, description.content && /*#__PURE__*/_react.default.createElement("div", {
          className: "d-flex flex-column",
          style: description.style
        }, /*#__PURE__*/_react.default.createElement("span", null, description.content))), /*#__PURE__*/_react.default.createElement("div", {
          className: "middle-text-wrapper"
        }, /*#__PURE__*/_react.default.createElement("div", null, part && /*#__PURE__*/_react.default.createElement("div", {
          className: " d-flex justify-content-between middle-text-content p-2",
          style: {
            borderBottom: "1px solid #EBEBEB"
          }
        }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
          headerStyle: {
            fontSize: 16,
            color: '#333333',
            fontWeight: 400
          },
          variant: "header-text",
          headerText: part
        }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
          headerStyle: {
            fontSize: 16,
            color: '#333333',
            fontWeight: 600
          },
          variant: "header-text",
          headerText: accessoryPartNumber
        })), installedDateText && /*#__PURE__*/_react.default.createElement("div", {
          className: "d-flex justify-content-between middle-text-content p-2",
          style: {
            borderBottom: "1px solid #EBEBEB"
          }
        }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
          headerStyle: {
            fontSize: 16,
            color: '#333333',
            fontWeight: 400
          },
          variant: "header-text",
          headerText: installedDateText
        }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
          headerStyle: {
            fontSize: 16,
            color: '#333333',
            fontWeight: 600
          },
          variant: "header-text",
          headerText: installedDate
        }))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
          headerStyle: {
            fontSize: 16,
            color: '#333333',
            marginTop: '10px'
          },
          variant: "header-text",
          headerText: filterLifeText
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: "status-content-container"
        }, statusImage ? /*#__PURE__*/_react.default.createElement("div", {
          className: "status-content"
        }, /*#__PURE__*/_react.default.createElement("img", {
          src: statusImage,
          alt: ""
        }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
          headerStyle: {
            fontSize: 27,
            color: '#4F8309',
            marginLeft: '10px',
            fontWeight: 600
          },
          variant: "header-text",
          headerText: statusText
        })) : null, note && /*#__PURE__*/_react.default.createElement("div", {
          className: "d-flex align-items-center",
          style: _objectSpread({}, note.style)
        }, note.iconLeft ? /*#__PURE__*/_react.default.createElement("img", {
          src: note.iconLeft,
          style: {
            paddingRight: 10,
            paddingTop: 5
          },
          alt: ""
        }) : null, /*#__PURE__*/_react.default.createElement("div", {
          className: "d-flex",
          style: {
            marginRight: 'auto',
            paddingTop: 5
          }
        }, note.description), note.iconRight ? /*#__PURE__*/_react.default.createElement("img", {
          src: note.iconRight,
          style: {
            paddingRight: 10,
            paddingTop: 5
          },
          alt: ""
        }) : null)))));
      default:
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "systemInfomation-wrapper",
          key: key
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "left-content-container"
        }, /*#__PURE__*/_react.default.createElement("img", {
          src: accessoryImageUrl,
          style: accessoryImageStyle,
          className: "system-accessory-image",
          alt: ""
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: "right-content-container"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "system-content"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "system-text-content"
        }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
          headerStyle: {
            fontSize: 16,
            color: '#333333'
          },
          variant: "header-text",
          headerText: accessoryName
        }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
          headerStyle: {
            fontSize: 13,
            color: '#333333'
          },
          variant: "header-text",
          headerText: accessoryType
        })), isArrowImageVisible ? /*#__PURE__*/_react.default.createElement("div", {
          onClick: onClickArrowRight,
          "data-testid": "arrowClick",
          className: editContainer
        }, /*#__PURE__*/_react.default.createElement("img", {
          src: arrowImageRight,
          className: "arrow-right-style",
          alt: "edit-filter"
        }), /*#__PURE__*/_react.default.createElement("div", {
          style: editStyle
        }, editTextRight)) : null), /*#__PURE__*/_react.default.createElement("div", {
          className: "middle-text-wrapper"
        }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
          className: "middle-text-content"
        }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
          headerStyle: {
            fontSize: 15,
            color: '#333333',
            fontWeight: 400,
            marginRight: 4
          },
          variant: "header-text",
          headerText: part
        }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
          headerStyle: {
            fontSize: 14,
            color: '#333333',
            fontWeight: 600
          },
          variant: "header-text",
          headerText: accessoryPartNumber
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: "middle-text-content"
        }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
          headerStyle: {
            fontSize: 15,
            color: '#333333',
            fontWeight: 400,
            marginRight: 4
          },
          variant: "header-text",
          headerText: installedDateText
        }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
          headerStyle: {
            fontSize: 14,
            color: '#333333',
            fontWeight: 600
          },
          variant: "header-text",
          headerText: installedDate
        })), filterParts ? /*#__PURE__*/_react.default.createElement("div", {
          className: "middle-text-content"
        }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
          headerStyle: {
            fontSize: 15,
            color: '#333333',
            fontWeight: 400,
            marginRight: 4
          },
          variant: "header-text",
          headerText: filterDateChangeText
        }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
          headerStyle: {
            fontSize: 14,
            color: '#333333',
            fontWeight: 600,
            marginTop: 10
          },
          variant: "header-text",
          headerText: filterDateChange
        })) : null), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
          headerStyle: {
            fontSize: 16,
            color: '#333333',
            marginTop: '10px'
          },
          variant: "header-text",
          headerText: filterLifeText
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: "status-content-container"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "status-content"
        }, /*#__PURE__*/_react.default.createElement("img", {
          src: statusLevelImage,
          alt: ""
        }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
          headerStyle: {
            fontSize: 27,
            color: '#4F8309',
            marginLeft: '0px',
            fontWeight: 600
          },
          variant: "header-text",
          headerText: statusLevelText
        })), accessoryLife && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
          headerStyle: {
            fontSize: 13,
            color: '#333333',
            fontWeight: 400
          },
          variant: "header-text",
          headerText: "".concat(accessoryLife)
        })))))));
    }
  };
  return getVariant(variant);
};
SystemTile.defaultProps = {
  accessoryImageUrlStyle: {
    maxHeight: 150,
    padding: '6px'
  }
};
var _default = exports.default = SystemTile;